import { Component, Input } from '@angular/core';
import { IconName } from '../icon/icon-data.generated';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-empty-state',
  imports: [IconComponent],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss',
})
export class EmptyStateComponent {
  @Input({ required: true }) iconName!: IconName;
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() hint?: string;
}
